import React from 'react'
import { IconsModel } from './iconsModel'

const SvgOther = (
	{
		color,
		width = 46,
		height = 46
	}: IconsModel
) => (
	<svg width={width} height={height} viewBox={`0 0 46 46`}>
		<g transform="translate(7 19)">
			<g
				fill="none"
				stroke={color}
				strokeWidth="1.8">
				<circle cx="4" cy="4" r="4" stroke="none"/>
				<circle cx="4" cy="4" r="3.1" fill="none"/>
			</g>
			<g
				transform="translate(12)"
				fill="none"
				stroke={color}
				strokeWidth="1.8">
				<circle cx="4" cy="4" r="4" stroke="none"/>
				<circle cx="4" cy="4" r="3.1" fill="none"/>
			</g>
			<g
				transform="translate(24)"
				fill="none"
				stroke={color}
				strokeWidth="1.8">
				<circle cx="4" cy="4" r="4" stroke="none"/>
				<circle cx="4" cy="4" r="3.1" fill="none"/>
			</g>
		</g>
		<g fill="none">
			<path
				d="M23,0A23,23,0,1,1,0,23,23,23,0,0,1,23,0Z"
				stroke="none"
			/>
			<path
				d="M 23 2 C 20.16414070129395 2 17.41415977478027 2.554958343505859 14.82646942138672 3.649459838867188 C 12.3260383605957 4.707050323486328 10.08000946044922 6.221511840820312 8.150760650634766 8.150760650634766 C 6.221511840820312 10.08000946044922 4.707050323486328 12.3260383605957 3.649459838867188 14.82646942138672 C 2.554958343505859 17.41415977478027 2 20.16414070129395 2 23 C 2 25.83585929870605 2.554958343505859 28.58584022521973 3.649459838867188 31.17353057861328 C 4.707050323486328 33.67395782470703 6.221511840820312 35.91999053955078 8.150760650634766 37.84923934936523 C 10.08000946044922 39.77848815917969 12.3260383605957 41.29294967651367 14.82646942138672 42.35054016113281 C 17.41415977478027 43.44504165649414 20.16414070129395 44 23 44 C 25.83585929870605 44 28.58584022521973 43.44504165649414 31.17353057861328 42.35054016113281 C 33.67395782470703 41.29294967651367 35.91999053955078 39.77848815917969 37.84923934936523 37.84923934936523 C 39.77848815917969 35.91999053955078 41.29294967651367 33.67395782470703 42.35054016113281 31.17353057861328 C 43.44504165649414 28.58584022521973 44 25.83585929870605 44 23 C 44 20.16414070129395 43.44504165649414 17.41415977478027 42.35054016113281 14.82646942138672 C 41.29294967651367 12.3260383605957 39.77848815917969 10.08000946044922 37.84923934936523 8.150760650634766 C 35.91999053955078 6.221511840820312 33.67395782470703 4.707050323486328 31.17353057861328 3.649459838867188 C 28.58584022521973 2.554958343505859 25.83585929870605 2 23 2 M 23 0 C 35.70254898071289 0 46 10.29745101928711 46 23 C 46 35.70254898071289 35.70254898071289 46 23 46 C 10.29745101928711 46 0 35.70254898071289 0 23 C 0 10.29745101928711 10.29745101928711 0 23 0 Z"
				stroke="none"
				fill={color}
			/>
		</g>
	</svg>
)

export default SvgOther
